module.exports = __webpack_public_path__ + "img/pic1.3ecd0ff2.png";